
export default (urlParameters) => {
  return {
    ads_allowed: true,
    complete_report_map: true,
    nc_wind_toggle_allowed: true,
    show_widgets: true,
    platform: 'web',
    promo_modal_allowed: true
  }
}